import get from 'lodash.get';

import { selectEntities } from 'services/entities/selectors';
import { TimesheetHoliday, TimesheetHolidayDate } from './types';
import { Entity, EntityId } from '../entities/types';
import { selectTimesheetHolidaysGroupedByDate } from './selectors';

type TimesheetHolidayRaw = TimesheetHoliday & { entities: Entity[] };

export const formatTimesheetHoliday = (
    timesheetHolidayRaw: TimesheetHolidayRaw
): TimesheetHoliday => {
    const { entities, ...others } = timesheetHolidayRaw;
    const entityIds: EntityId[] = [];

    entities.forEach(({ id }) => {
        if (id) {
            entityIds.push(id);
        }
    });

    return {
        ...others,
        entityIds
    };
};

export const formatTimesheetHolidays = (
    timesheetHolidays: TimesheetHolidayRaw[]
): TimesheetHoliday[] => {
    return timesheetHolidays.map(formatTimesheetHoliday);
};

export const findEntityHolidayByDate = (
    timesheetDate: TimesheetHolidayDate,
    timesheetEntityId: EntityId,
    timesheetHolidaysGroupedByDate: ReturnType<
        typeof selectTimesheetHolidaysGroupedByDate
    >,
    entities: ReturnType<typeof selectEntities>
): TimesheetHoliday | undefined => {
    const holidaysByDate = get(
        timesheetHolidaysGroupedByDate,
        timesheetDate,
        []
    );

    if (!holidaysByDate.length) {
        return undefined;
    }

    const entityPath = get(entities, [timesheetEntityId, 'path'], '');

    const pathEntityIds = (entityPath && entityPath.split('/')) || [];
    pathEntityIds.shift();

    pathEntityIds.push(timesheetEntityId.toString());

    return holidaysByDate.find((holiday) =>
        pathEntityIds.find((entityId) =>
            holiday.entityIds.includes(Number(entityId))
        )
    );
};
